import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import Redirect from 'react-router/Redirect';
import { branch, compose, renderComponent } from "recompose";
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { isBusinessAdmin } from '../../../../services';
import { taskActions } from '../../../../state/modules/task';
import Loading from '../../loading';

const ChooseCpdAllocation = ({
  task: { type },
  setCpdAllocation
}) => (<div id="choose-cpd-allocation">
  <Grid>
    <Row className='no-gutter'>
      <Col xs={12} md={8} mdOffset={2} className='no-padding'>
        <h1>
          Does your {type} count
          towards a users CPD progress?
        </h1>
      </Col>
    </Row>
    <Row className='no-gutter'>
      <Col md={2} mdOffset={4} className='no-padding'>
        <LinkContainer onClick={() => setCpdAllocation(true)} to={routes.app.tasks.details}>
          <Button>Yes</Button>
        </LinkContainer>
      </Col>
      <Col md={2} className='no-padding'>
        <LinkContainer onClick={() => setCpdAllocation(false)} to={routes.app.tasks.details}>
          <Button>No</Button>
        </LinkContainer>
      </Col>
    </Row>
    <Row className='no-gutter'>
      <Col xs={12} md={8} mdOffset={2} className='no-padding'>
        <LinkContainer to={routes.app.tasks.chooseTaskType}>
          <Button bsStyle="plain">Go back to previous step.</Button>
        </LinkContainer>
      </Col>
    </Row>
  </Grid>
</div>);

const mapStateToProps = (state) => ({
  isBusinessAdmin: isBusinessAdmin(state.user.currentUser),
  task: state.task.createTask
});

const mapDispatchToProps = (dispatch) => ({
  setCpdAllocation: bindActionCreators(taskActions.task.setCpdAllocation, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ task }) => !(task && task.type),
    renderComponent(() => <Redirect to={routes.app.tasks.chooseTaskType} />)
  ),
  branch(
    ({ isBusinessAdmin }) => !isBusinessAdmin,
    renderComponent(Loading)
  )
)(ChooseCpdAllocation)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/choose-cpd-allocation.js